import { useState } from 'react';
import { motion } from 'framer-motion';
import './TermsGate.css';

const TERMS_KEY = 'patrik_terms_v1';

export const hasAcceptedTerms = () => {
  try { return localStorage.getItem(TERMS_KEY) === '1'; } catch { return true; }
};

/** Одноразовое окно пользовательского соглашения (показывается 1 раз при первом запуске). */
export const TermsGate = ({ onAccept }: { onAccept: () => void }) => {
  const [closing, setClosing] = useState(false);
  const accept = () => {
    try { localStorage.setItem(TERMS_KEY, '1'); } catch { /* ignore */ }
    setClosing(true);
    setTimeout(onAccept, 200);
  };
  return (
    <motion.div className="terms-gate" initial={{ opacity: 0 }} animate={{ opacity: closing ? 0 : 1 }}>
      <motion.div className="terms-card" initial={{ y: 24, opacity: 0 }} animate={{ y: 0, opacity: 1 }} transition={{ duration: 0.35 }}>
        <div className="terms-head">
          <img src="/logo.png?v=2" alt="" className="terms-logo" />
          <h2>Пользовательское соглашение</h2>
        </div>
        <div className="terms-body">
          <p><b>1. Общие положения</b><br />1.1. Настоящее Соглашение регулирует порядок использования сервиса.<br />1.2. Используя Сервис, Пользователь подтверждает согласие.</p>
          <p><b>2. Отказ от ответственности</b><br />2.1. Сервис предоставляется «как есть» (AS IS).<br />2.2. Администрация не несёт ответственности за убытки, действия третьих лиц, сбои.<br />2.3. Все риски возлагаются на Пользователя.</p>
          <p><b>3. Ограничения</b><br />3.1. Пользователь оценивает законность действий самостоятельно.<br />3.2. Запрещено использование для противоправной деятельности.<br />3.3. Администрация вправе ограничить доступ без уведомления.</p>
          <p><b>4. Конфиденциальность</b><br />Администрация собирает минимум данных для работы Сервиса.</p>
          <p><b>5. Изменения</b><br />Администрация вправе изменять условия без уведомления.</p>
          <p><b>6. Применимое право</b><br />Споры регулируются законодательством юрисдикции Администрации.</p>
          <p><b>7. Условия возврата</b><br />7.1. Возврат цифровых услуг невозможен после предоставления.<br />7.2. Возврат возможен если услуга не оказана по техническим причинам.<br />7.3. Обращение в поддержку в течение 24 часов с момента оплаты.<br />7.4. Решение о возврате принимается индивидуально.</p>
          <p>Начиная использование сервиса, Пользователь принимает условия Соглашения.</p>
          <p>В решении вопросов: @Patrik_vpn_support</p>
        </div>
        <button className="terms-accept" onClick={accept}>Принимаю и продолжить</button>
      </motion.div>
    </motion.div>
  );
};
